/* @flow */

export { ZalgoPromise } from './promise';
